import { createAifcDebugSelectionsEffect } from '@databases/devtools/selections-effect';
import { getService } from '@databases/service-container';
import { TABLE_V2_LAYOUT_ID } from '@databases/view-layout-table-v2/id';

import {
  SelectionFeatureKeys,
  type SelectionEffectFeature,
} from '../../features/types.ts';

export function createAifcDebugSelectionsEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.AIFC_DEBUG_SELECTIONS_EFFECT,
    type: 'effect',
    isEnabled: ({ layoutType }) => layoutType !== TABLE_V2_LAYOUT_ID,
    factory: () =>
      createAifcDebugSelectionsEffect({
        selectionsApi: getService('SelectionsApi'),
      }),
  };
}
